// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown-solid[data-v-8f1ecf14] {\n  background-color: #2db782;\n  border: 1px solid #2db782;\n  color: #fff;\n  font-weight: 400;\n  width: auto;\n  height: 38px;\n}", ""]);
// Exports
module.exports = exports;
